import "./loader.css";
import { Subject } from "rxjs"
import * as React from "react";

export const loaderStatus = new Subject();

export interface LoaderProps { }
export interface LoaderState {
    loadingStatus: boolean
}

const LoadingContainer = () => {
    return (
        <div className="loader-container">
            <div className="loader">
                <div className="lds-grid">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                </div>
            </div>
        </div>
    );
};

export class Loader extends React.Component<
    LoaderProps,
    LoaderState
    > {

    constructor(props: LoaderProps) {
        super(props);
        this.state = {
            loadingStatus: false
        };
    }

    componentWillMount() {
        // Subscribe to loaderStatus to detect the changes emitted by the any other component
        // If true then it will turn on the loader
        // if false then it will turn off the loader
        loaderStatus.subscribe(result => {
            this.setState({ loadingStatus: result ? true : false });
        });
    }

    // Checking if loadingStatus is true the return the LoadingContainer
    // Else return null
    render() {
        const { loadingStatus } = this.state;
        return loadingStatus ? <LoadingContainer /> : null;
    }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/shared/loader/loader.tsx